import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs';

@Injectable()
export class ErrorLoggerService {
	constructor(private _http: Http) {
	}

	logError(message: string) {
		console.error(message);
	}
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/core/services/error-logger.service.ts